<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * This is designed to be called on the login page to clean out any old cached searches from a previous login
    *
    * @since 20201008
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <span></span>
</template>

<script>
    export default{
        props: {
            //the saveSearchNames to clear
            saveSearchNames: {
                type: Array
            },
            //the websites
            websites: {
                type: Array
            },
        },
        mounted() {
            try {
                for(var i=0; i<this.saveSearchNames.length; i++){
                    for(var j=0; j<this.websites.length; j++){
                        localStorage.removeItem("search_" + this.saveSearchNames[i] + '_' + this.websites[j].id);
                        localStorage.removeItem("filters_" + this.saveSearchNames[i] + '_' + this.websites[j].id);
                        localStorage.removeItem("page_" + this.saveSearchNames[i] + '_' + this.websites[j].id);
                        localStorage.removeItem("limit_" + this.saveSearchNames[i] + '_' + this.websites[j].id);
                        localStorage.removeItem("order_column_" + this.saveSearchNames[i] + '_' + this.websites[j].id);
                        localStorage.removeItem("order_direction_" + this.saveSearchNames[i] + '_' + this.websites[j].id);
                        localStorage.removeItem("archived_" + this.saveSearchNames[i] + '_' + this.websites[j].id);
                    }
                }
            } catch(err) {
            }
        }
    }
</script>